import { TableColumn, TableRow, TableStylesType } from './types';

import styles from './fixed-first-column-table.module.scss';

export const getStyleClass = (tableStyle: TableStylesType) => {
  switch (tableStyle) {
    case 'styled-light-green':
      return styles.styledLightGreen;
    default:
      return styles.default;
  }
};

export const getCellAlignment = (align?: string) => {
  switch (align) {
    case 'center':
      return styles.textCenter;
    case 'right':
      return styles.textRight;
    default:
      return styles.textLeft;
  }
};

// Transform data and columns when transposed
export const getTransformedData = ({
  transposed,
  data,
  columns,
}: {
  transposed: boolean;
  data: TableRow[];
  columns: TableColumn[];
}) => {
  if (!transposed) {
    return { transformedData: data, transformedColumns: columns };
  }

  // In transposed mode:
  // - First column values become the new column headers
  // - Original column headers become the new first column
  // - Data matrix is transposed

  const firstColumnKey = columns[0].key;
  const newColumnHeaders = data.map((row) => row[firstColumnKey]);

  // Create new columns: first column for original headers, then one for each row
  const transformedColumns: TableColumn[] = [
    {
      key: 'originalHeader',
      header: '', // Empty header for the first column
    },
    ...newColumnHeaders.map((header, index) => ({
      key: `col_${index}`,
      header: String(header?.text || ''),
      align: 'left' as const,
    })),
  ];

  // Create new data: each original column (except first) becomes a row
  const transformedData: TableRow[] = columns.slice(1).map((column) => {
    const newRow: TableRow = {
      originalHeader: { text: column.header },
    };

    // For each data row, get the value for this column
    data.forEach((dataRow, dataIndex) => {
      const value = dataRow[column.key];
      newRow[`col_${dataIndex}`] = value;
    });
    return newRow;
  });

  return { transformedData, transformedColumns };
};
